import { render, staticRenderFns } from "./rentacarkategori.vue?vue&type=template&id=05a5c34c&"
import script from "./rentacarkategori.vue?vue&type=script&lang=js&"
export * from "./rentacarkategori.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports